export default {
  headline: {
    fontFamily: 'Inter',
    color: 'rgba(255, 255, 255, 1)',
  },
  text: {
    fontFamily: 'Inter',
    color: 'rgba(255, 255, 255, 1)',
  },
  spacer: {
    color: 'rgba(0, 0, 0, 0)',
  },
  button: {
    fontFamily: 'Inter',
    color: 'rgba(255, 255, 255, 1)',
    borderColor: 'rgba(255, 255, 255, 1)',
    backgroundColor: 'rgba(133, 0, 27, 1)',
  },
  rank: {
    baseColor: 'rgba(133, 0, 27, 1)',
  },
  image: {
    backgroundColor: 'rgba(0, 0, 0, 0)',
  },
  field: {
    fontFamily: 'Inter',
    color: 'rgb(0, 0, 0)',
    borderColor: 'rgba(255, 255, 255, 1)',
    backgroundColor: 'rgba(254, 254, 254, 1)',
  },
  social: {
    color: 'rgb(0, 0, 0)',
  },
  survey: {
    color: 'rgba(254, 254, 254, 1)',
    borderColor: 'rgb(0, 0, 0)',
    backgroundColor: 'rgba(0, 0, 0, 1)',
  },
  wheel: {
    fontFamily: 'Inter',
    color: 'rgba(254, 254, 254, 1)',
    borderColor: 'rgb(0, 0, 0)',
    backgroundColor: 'rgba(0, 0, 0, 1)',
    secondaryBackgroundColor: 'rgba(133, 0, 27, 1)',
  },
  voucher: {
    fontFamily: 'Inter',
    fontWeight: 'bold',
    color: 'rgba(255, 255, 255, 1)',
    borderColor: 'rgba(255, 255, 255, 1)',
  },
  checkbox: {
    color: 'rgba(255, 255, 255, 1)',
    borderColor: 'rgba(255, 255, 255, 0)',
    checkboxColor: 'rgba(255, 255, 255, 1)',
    backgroundColor: 'rgba(0, 0, 0, 1)',
  },
}
